
export const ACTION_UPDATE = 'account/ACTION_UPDATE';
export const ACTION_LOAD_ACCOUNT = 'account/ACTION_LOAD_ACCOUNT';
export const ACTION_LOAD_ACTIVITIES = 'account/ACTION_LOAD_ACTIVITIES';
export const ACTION_LOAD_MORE_ACTIVITIES = 'account/ACTION_LOAD_MORE_ACTIVITIES';
